import useList from '../_basic/list';
import useItem from '../_basic/item';
import gqlItem from './item.graphql';
import gqlList from './list.graphql';

const dataset = new useItem(gqlItem);
const datasets = new useList(gqlList);

export default function() {
  return {
    dataset,
    datasets
  };
}
